export default __webpack_public_path__ + "static/media/meetRoomSelect.ffdf3c81.svg";